/*
Sohel 11/28/2022  3031450488 Filter Save API payload Changes
Saikrishna 11/28/2022  3031450488 Fixed prepopulation bugs
Sohel 11/28/2022  3031450488 Added Test Button
Sohel 11/28/2022  3031450488 Fixed Date Issue
Gummala Prakash 11/28/2022 3031450488 Fixed Button Alignment.
Saikrishna  11/29/2022  3031450488 Test API integration done
Prakash 12/01/2022 3031450488 Added Margin dense for Field.
Sai maheshwar 12/02/2022 3031450488 added AND/OR condition for rule builder.
Sai maheshwar 12/02/2022 3031450488 fixed AND/OR condition issue rule builder.
lalitha 12/03/2022 3031450488 Radio button color changed
Sohel 12/05/2022 3031450488 Added PageLoader
Rohini 12/05/2022 3031450488 added classname for the text field
Sai Maheshwar 12/05/2022 3031450488 added map fields save and close
Dilip 12/05/2022  3031450488 Removed unecesarry console.log statements
Saikrishna 12/06/2022 3031450488 Fixed form data reset bug after selecting filter condition.
Ravi 12/07/2022 3031450488 Fixed UAT bugs
kavya9reddy 12/08/2022 3031450488 Added save button
Sai maheshwar 12/08/2022 3031450488 fixed unsaved changes alert bug
Sohel 12/13/2022 3031450488 conditionally hide Save Button
Raghuarun 12/21/2022 3031450488 button spacing alignments
akhila 12/21/2022 3031450488 fixed validations for filterMethods
akhila 12/23/2022 3031450488 changed test popup title
sai Krishna 12/23/2022 3031450488 add Work Queue code, Reportcode  and Work Queue description,Report description
lalitha 12/26/2022 3031450488 fixed prepopulating issue of report code and report description when clicked on edit
Sai Maheshwar 12/12/2022 2700912712 fixed delete rule issue
Ashraf 12/27/2022  3031450488  fixed page break issue
kavyareddy 01/04/2023 2700912712 Added reportType in payload
Dilip 01/04/2023 2700912712 fixed disable issue of add icon
kavyareddy 01/05/2023 2700912712 Fixed test disable issue
Akhila 01/09/2023 2700912712 Fixed double loader issue
sai Krishna 12/23/2022 2700912712 fixed tooltip issue
Ravi 02/02/2023 2700912712 rename validation Message Deposition to status
Sohel 02/09/2023 2700912712 Fixed Filter button disabled issue
Suresh Peddavoora 02/09/2023 2700912712 Added Classname for Textfield Enhancements
Sohel 02/16/2023 2700912712 Fixed Validation Issue
Ravi 02/21/2023 2700912712 Display field Data Above the Add Filter Rule Button
suresh peddavoora 02/27/2023 2700912712 New UI changes and fields alignments
Ravi 02/28/2023 2700912712 fixed Add Filter Rule delete issue
Ravi 03/09/2023 2700912712 Added Validate popup on save button
Rohini 03/14/2023 2700912712 fixed the responsive for tab .
Ravi 03/25/2023 2700912712 Added GuiAutoComplete textField
Rohini 03/27/2023 2700912712 fixed the alignments for responsive.
Ravi 03/30/2023 2700912712 fixed reset issue
Raghu 04/05/2023 2700912712 fixed input feilds in responsive
Prakash 10/04/2023 2700912712 fixed ratio button color.
Prakash 13/04/2023 2700912712 remove margin bottom
Sohel 04/18/2023 2700912712 Fixed Delete Id Issue and Test Button Changes
Prakash 20/04/2023 2700912712 remove  bottom  spacing issue
Sohel  04/25/2023 2701127043 Added Data Calculation Field
Guru Prasad  04/25/2023 2701127043 Fixed button alignments
Sohel 04/05/2022 2692790263 FIxed Filter Method Validation issue
Sohel 04/08/2022 2692790263 FIxed Filter Method Validation issue
Sohel 04/08/2022 2692790263 Fixed Add Filter popup issue
Ravi 05/09/2023 2692790263 Added validation in Action
Sohel 05/10/2022 2692790263 Fixed Filter Validation Issue
Akhila 05/11/2022 2692790263 bug fixed action field render
Sohel 05/12/2022 2692790263 Fixed Filter Method Action Issue
Ravi 05/17/2023 2692790263  fixed validation issue
Sohel 05/24/2023 2692790263 Added Values Field Validation
Sohel 05/24/2023 2692790263 Added Required Validation
Akhila 05/9/2022 2692790263 unsaved changes popup bug fix
Ravi 05/31/2023 2692790263 changed delete popup message
Sohel 06/02/2023 2692790263 Fixed Repository Name and Field Name issue
Akhila 06/03/2023 2692790263 bug fixed validation on between and not between field
Sohel 06/08/2023 3075234474 Added Between and Not Between condition For Account By status
Sohel 06/08/2023 3075234474 Change Payload
Sohel 06/09/2023 3075154998 Values Field Changes
Sohel 06/09/2023 3075154998 Fixed Prepopulate Issue
Sohel 06/09/2023 3075154998 Fixed repository and field name Prepopulate Issue
Ravi 06/14/2023 3075154998 fixed action reset issue
Akhila 06/16/2023 3075154998 Added Total and T conditonally in sql output for date field type
Akhila 06/19/2023 3075154998 filter method field by list date changes field TODAY or T
Ravi 06/20/2023 2692790263 Added Breadcrum in popup
Sohel 06/21/2023 2692790263 Fixed Field Prepopulate issue
Ravi 07/07/2023 2692790263 Fixed respository field Prepopulate issue
Sohel 10/05/2023 5155351299 Added TableColumn Name in payload
Sohel 10/09/2023 5155351299 Fixed TableColumn Name populate Issue
*/
import {
  Button,
  TextField,
  FormHelperText,
  FormControl,
} from '@material-ui/core';
import React, {useState, useEffect, useContext, useRef} from 'react';
import DialogBox from '../../../../../components/DialogBox';
import * as Yup from 'yup';
import {
  testFilterResetData,
} from '../../../../../redux/reducers/BRE/AddRuleGroup';
import {useDispatch, useSelector} from 'react-redux';
import {ThemeContext} from '../../../../../themes/ThemeProvider';
import AddIcon from '@material-ui/icons/Add';
import TestComponent from '../../../BRE/FilterRuleGroup/AddFilterRuleGroup/TestComponent';
import {
  postFilter,
  resetMessage,
  fetchFilter,
  fetchBasicInfo,
  fetchReportFields,
} from '../../../../../redux/reducers/ReportMaster/index';
import PageLoader from '../../../../../components/PageLoader';
import {ErrorSnackbar, SuccessSnackbar} from '../../../../../components/CustomSnackBar';
import {Field, FieldArray, Form, Formik} from 'formik';
import {FormControlLabel, Radio, RadioGroup} from '@mui/material';
import * as yup from 'yup';

import {
  getActions,
  getClientCodeData,
  getCollectorsData,
  getDropDownData,
  getFieldCode,
  postFieldCode,
} from '../../../../../redux/reducers/BRE/AddReportMaster';
import GetAccessMethodFields from '../../../ReportMaster/SearchReportMaster/GetAccessMethodFields';
import SearchFields from '../../../GlobalFields/DataRepositories/SearchDataRepositories/index';
import GuiAutoComplete from '../../../../../components/FormComponents/GuiAutoComplete';
import GuiTextField from '../../../../../components/FormComponents/GuiTextField';
import {REPORTING_EXPORT, WORK_QUEUE_SETUP} from '../../../../../constants/ReusableRoleAccess';
import BreadCrums from '../../../../../util/BreadCrum';
import SqlRuleBuilder from '../../../../../components/SqlRuleBuilder';
import DeleteTableRecordPopup from '../../../../../util/DeleteTableRecordPopup';
import {
  fetchUserDefinedFields,
  fetchUserDefinedWindows,
} from '../../../../../redux/reducers/EventTactics/EventTactics';
import {getOptions} from '../../../../../components/SqlRuleBuilder/utils';
import SearchDataCalculationFields from '../../../BRE/FormulaRuleGroup/SearchRuleGroup';
import {
  submissionEnd,
  submissionStart,
} from '../../../../../redux/reducers/CommonActions/commonActions';

const Filters = ({handleNext, handleBack, handleDirty, workQueue, editExisting}) => {
  const {reusableInputStyles} = useContext(ThemeContext);
  const classes = reusableInputStyles();
  const dispatch = useDispatch();
  const {
    promptData,
    fieldCodeData,
    actionData,
    isLoading: actionLoader,
  } = useSelector(({addReportMaster}) => addReportMaster);
  const {enabledSubmission} = useSelector(({commonActions}) => commonActions);

  const [openTestForm, setOpenTestForm] = useState(false);
  const dirtyRef = useRef(false);
  const resetPromptDataRef = useRef(false);
  const {
    addFilterStatus,
    getfilterData,
    reportCode,
    successMsg,
    errorMsg,
    basicInfoData,
  } = useSelector(({reportMaster}) => reportMaster);
  const formDataRef = useRef();
  const getObject = (option, options) => {
    let label = {};
    options &&
      options.length > 0 &&
      options.forEach((item) => {
        if (item.fieldCode === option) {
          label = item;
        }
      });
    return label;
  };
  const [dirtyval, setDirtyVal] = useState(false);
  const filterMethodRef = useRef({});
  const arrayHelperRef = useRef();
  const [deletedRules, setDeletedRules] = useState([]);
  // const [rules, setRules] = useState([]);
  const [open, setOpen] = useState(false);
  const clickedTestRef = useRef('');
  const [tempSelectedRows, setTempSelectedRows] = useState([]);
  const resultRef = useRef();
  const {roleData} = useSelector(({role}) => role);
  const reportRoleAccess = roleData?.window?.[REPORTING_EXPORT]?.RE;
  const workQueueSetupAccess = roleData?.window?.[WORK_QUEUE_SETUP]?.WQS;
  const [isDelete, setIsDelete] = useState(false);
  const [validate, setValidate] = useState(false);
  const [saveLoading, setSaveLoading] = useState(false);
  const [filterRuleOpen, setFilterRuleOpen] = useState(false);
  const [fieldSubmitted, setSubmitted] = useState(false);
  const currentDeleteIndex = useRef(null);
  const roleAccess =
    (workQueue && getfilterData && !workQueueSetupAccess?.edit && editExisting) ||
    (!workQueue && getfilterData && !reportRoleAccess?.edit && editExisting);
  const initialVal = {
    resultExpCondition:
      getfilterData?.defaultOperator == null ? 'AND' : getfilterData?.defaultOperator,
    accessMethod:
      getfilterData?.accessMethodInfo?.accessMethod && fieldCodeData?.length ?
        getObject(getfilterData?.accessMethodInfo?.accessMethod, fieldCodeData) :
        '',
    sqlRules: [],
    sqlExpression: '',
    action: getfilterData?.accessMethodInfo?.action ? getfilterData?.accessMethodInfo?.action : '',
    repoitoryName: null,
    fieldsName: '',
  };
  const {userDefinedWindowData, userDefinedFieldsData} = useSelector(
    ({addEventTactic}) => addEventTactic,
  );
  const [initialValues, setInitialValues] = useState(initialVal);
  const filterRuleRoleAccess =
    roleData?.window?.['Filter Rules']?.['FR'] || roleData?.window?.['Reporting/Export']?.['RE'];

  const validationSchema = yup.object().shape({
    sqlRules: Yup.array().of(
      Yup.object().shape({
        field: Yup.mixed().required('Field is required'),
        condition: Yup.mixed().required('Condition is required'),
        value: Yup.mixed().when('condition', {
          is: (val) => {
            return !['isNotBlank', 'isBlank'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
        value1: Yup.mixed().when('condition', {
          is: (val) => {
            return ['BETWEEN', 'NOT BETWEEN'].includes(val?.value);
          },
          then: Yup.mixed().required('Value is required'),
        }),
      }),
    ),
    accessMethod: yup.mixed().test('accessMethod', 'Filter Method is required', (value) => {
      if (!value?.fieldCode) {
        return false;
      } else {
        return true;
      }
    }),
    action:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBACCT' ?
        null :
        yup.mixed().required('Action is required'),
    // sqlExpression: yup.string().required("Result Expression is required"),
    sqlExpression: Yup.string().test('sqlExpression', 'Result Expression is required', (value) => {
      if (!value && formDataRef.current?.values?.sqlRules?.length > 0) {
        return false;
      } else {
        return true;
      }
    }),
    client:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBCLNT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      Yup.array().test('client', 'Client is required', (val) => {
        if (val?.length > 0) {
          return true;
        } else {
          return false;
        }
      }),
    disposition:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DSDISP' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      Yup.array().test('dispo', 'Status is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    phase:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DSSTAT' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      Yup.array().test('phase', 'Phase is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    collectors:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBCOLLECTOR' &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      Yup.array().test('collector', 'Collector is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    Date:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['<', '>'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      // yup.date().typeError().nullable().required("Date is required"),
      Yup?.mixed().test('Date', 'Values is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    startDate:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      // yup.date().typeError().nullable().required("Start date is required"),
      Yup.mixed().test('startDate', 'From Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    lastDate:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBLSTDTE' &&
      ['Between'].includes(formDataRef?.current?.values?.action) &&
      !['Is Blank', 'Is Not Blank']?.includes(formDataRef?.current?.values?.action) &&
      // yup
      //   .date()
      //   .typeError()
      //   .nullable()
      //   .required("End date is required")
      //   .min(yup.ref("startDate"), "End date should be greater than start date"),
      Yup.mixed().test('lastDate', 'To Values is required', (val) => {
        if (!val) {
          return false;
        } else {
          return true;
        }
      }),
    repoitoryName:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      // !["Is Null", "Is Not Null"]?.includes(formDataRef?.current?.values?.action) &&
      Yup.mixed().required('Repository Name is required').nullable(),
    fieldsName:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      // !["Is Null", "Is Not Null"]?.includes(formDataRef?.current?.values?.action) &&
      Yup.mixed().required('Field Name is required').nullable(),
    values:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      !['Is Blank', 'Is Not Blank', 'BETWEEN', 'NOT BETWEEN']?.includes(
        formDataRef?.current?.values?.action,
      ) &&
      Yup.mixed().test('Values', 'Values is required', (val) => {
        if (val?.length) {
          return true;
        } else {
          return false;
        }
      }),
    toValues:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      ['BETWEEN', 'NOT BETWEEN']?.includes(formDataRef?.current?.values?.action) ?
        Yup.mixed().test('toValues', 'To Values is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
    fromValues:
      formDataRef?.current?.values?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
      ['BETWEEN', 'NOT BETWEEN']?.includes(formDataRef?.current?.values?.action) ?
        Yup.mixed().test('fromValues', 'From Values is required', (val) => {
          if (!val) {
            return false;
          } else {
            return true;
          }
        }) :
        null,
  });
  const handleDeleteClose = () => {
    setIsDelete(false);
  };
  const handleResultExpression = (arr, setFieldValue, resultExpCondition) => {
    if (!resultRef.current) {
      const result = arr.map((el, i) => el.ruleCode);
      if (result.length > 0 && resultExpCondition) {
        setFieldValue('sqlExpression', result.join(` ${resultExpCondition} `));
      } else {
        setFieldValue('resultExpCondition', 'AND');
        setFieldValue('sqlExpression', '');
      }
    }
  };
  const handleDeleteRule = () => {
    const i = currentDeleteIndex.current;
    const {
      form: {values, setFieldValue},
    } = arrayHelperRef.current;
    const copyArr = [...values.sqlRules];
    const copyDeleteArr = [...deletedRules];
    if ('reportRulesList' in getfilterData) {
      copyDeleteArr.push(getfilterData?.reportRulesList[i]?.reportRulesId);
    }
    copyArr.splice(i, 1);
    // if (handleExpression) {
    //   handleExpression(copyArr);
    // }
    // setRules(copyArr);
    setDeletedRules(copyDeleteArr.filter(Boolean));
    if (arrayHelperRef.current) {
      arrayHelperRef.current.remove(currentDeleteIndex.current);
      handleResultExpression(copyArr, setFieldValue, values.resultExpCondition);
    }
    setIsDelete(false);
  };

  // useEffect(() => {
  //   handleDirty(false, "reset");
  // }, []);
  useEffect(() => {
    if (dirtyRef.current === true || dirtyval) {
      handleDirty(true);
    } else {
      handleDirty(false, 'reset');
    }
  }, [dirtyRef.current, dirtyval]);
  useEffect(() => {
    if (reportCode) {
      dispatch(fetchFilter(reportCode));
    }
  }, [reportCode]);

  const handleValidationClose = () => {
    setValidate(false);
    dispatch(submissionEnd());
  };

  useEffect(() => {
    if (getfilterData?.accessMethodInfo?.accessMethod) {
      const newInitialValues = {...initialValues};

      newInitialValues.accessMethod = getfilterData?.accessMethodInfo?.accessMethod ?
        getObject(getfilterData?.accessMethodInfo?.accessMethod, fieldCodeData) :
        getObject('DBACCT', fieldCodeData);
      newInitialValues.action = getfilterData?.accessMethodInfo?.action ?
        getfilterData?.accessMethodInfo?.action :
        '';
      (newInitialValues.resultExpCondition =
        getfilterData?.defaultOperator == null ? 'AND' : getfilterData?.defaultOperator),
      (newInitialValues.sqlExpression = getfilterData?.ruleExpression);
      filterMethodRef.current = newInitialValues.accessMethod;
      const newRules =
        getfilterData?.reportRulesList?.length > 0 ?
          getfilterData?.reportRulesList?.map((el) => {
            return {
              ...el,
              field: {
                ...el,
                repositoryName: el.repository,
                dataType: el?.fieldType ? el?.fieldType : 'text',
                globalField: el?.tableColumnName,
              },
              condition: getOptions(el?.fieldType?.toLowerCase())?.filter(
                (e) => e.value === el.filterCondition,
              )[0],
              // condition: null,
              sqlValue: el.sqlExpression,
            };
          }) :
          [];
      setInitialValues((prevState) => ({...prevState, ...newInitialValues, sqlRules: newRules}));
      if (getfilterData?.accessMethodInfo?.accessMethod) {
        dispatch(getActions(getfilterData?.accessMethodInfo?.accessMethod));
        dispatch(
          postFieldCode({
            fieldCode: getfilterData?.accessMethodInfo?.accessMethod,
            options: getfilterData?.accessMethodInfo?.action,
          }),
        );
      }
    }
  }, [getfilterData, fieldCodeData]);
  useEffect(() => {
    dispatch(getFieldCode());
    dispatch(getCollectorsData());
    dispatch(getDropDownData());
    dispatch(getClientCodeData());
    dispatch(fetchUserDefinedWindows());
  }, []);
  const getActionsValues = (type, dropdownData) => {
    if (['amount', 'number', 'date']?.includes(type?.toLowerCase())) {
      return dropdownData?.length > 0 ? dropdownData : [];
    } else {
      const data =
        dropdownData?.length > 0 ?
          dropdownData?.filter((el) => !['BETWEEN', 'NOT BETWEEN']?.includes(el)) :
          [];
      return data;
    }
  };
  const getValue = (values) => {
    const a = values?.split(' ')?.join('');
    const dateValue = values?.length > 1 ? values?.slice(0, 5) :'';
    if (dateValue?.toUpperCase() === 'TODAY') {
      return a?.replace(dateValue, 'cast(now()as date)');
    } else if (values?.charAt(0)?.toUpperCase() === 'T') {
      return a?.replace(values?.charAt(0), 'cast(now()as date)');
    } else {
      return values;
    }
  };
  useEffect(() => {
    if (addFilterStatus === 200) {
      setTimeout(() => {
        if (clickedTestRef.current) {
          handleValidationClose();
        }
        !clickedTestRef.current && handleNext();
        dispatch(resetMessage());
        dispatch(fetchFilter(reportCode));
      }, 2500);
    }
  }, [addFilterStatus]);
  const handleTestFormClose = () => {
    dispatch(testFilterResetData());
    setOpenTestForm(false);
  };
  useEffect(() => {
    if (errorMsg || successMsg) {
      setSubmitted(false);
      setTimeout(() => {
        dispatch(resetMessage());
      }, 2500);
      setSaveLoading(false);
    }
  }, [errorMsg, successMsg]);

  const getArrayData = (selectedAccessMethod, data) => {
    if (selectedAccessMethod === 'DBCOLLECTOR') {
      return data?.collectors && data?.collectors.length > 0 ?
        data?.collectors.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSDISP') {
      return data?.disposition && data?.disposition.length > 0 ?
        data?.disposition.map((i) => {
          return i.valueCode;
        }) :
        [];
    } else if (selectedAccessMethod === 'DBCLNT') {
      return data?.client && data?.client.length > 0 ?
        data?.client.map((i) => (i.clientCode ? i.clientCode : i)) :
        [];
    } else if (selectedAccessMethod === 'DSSTAT') {
      return data?.phase && data?.phase.length > 0 ? data?.phase.map((i) => i?.valueCode) : [];
    } else if (selectedAccessMethod === 'DBUDWFIELDS') {
      return data?.values && data?.values.length > 0 ?
        data?.values.map((i) => {
          if (data?.fieldsName?.fieldType?.toLowerCase() === 'date') {
            return getValue(i);
          } else {
            return i;
          }
        }) :
        [];
    } else {
      return [];
    }
  };
  const handleClose = () => {
    setOpen(false);
    setFilterRuleOpen(false);
  };
  useEffect(() => {
    if (
      actionData?.length > 0 &&
      !getfilterData?.accessMethodInfo?.accessMethod &&
      filterMethodRef.current
    ) {
      const newInitialValues = {...initialValues};
      if (filterMethodRef.current) {
        newInitialValues.accessMethod = filterMethodRef.current;
      }
      newInitialValues.action = actionData[0];
      setInitialValues((prevState) => ({...prevState, ...newInitialValues}));
      dispatch(
        postFieldCode({
          fieldCode: filterMethodRef.current?.fieldCode,
          options: actionData[0],
        }),
      );
    }
  }, [actionData]);
  useEffect(() => {
    if (reportCode) {
      dispatch(fetchBasicInfo(reportCode));
    }
  }, [reportCode]);
  const handleSubmit = (data) => {
    if (data?.sqlRules?.length === 0 && formDataRef.current?.values?.accessMethod !== '') {
      setValidate(true);
    } else if (data?.sqlRules?.length > 0) {
      dispatch(submissionStart());
      setSaveLoading(true);
      const selectedAccessMethod = data?.accessMethod?.fieldCode;
      const sqlRules =
        data?.sqlRules?.length > 0 ?
          data?.sqlRules?.map((item, i) => {
            return {
              reportRulesId: item?.reportRulesId ? item?.reportRulesId : 0,
              ruleCode: item?.ruleCode,
              fieldName: item?.field?.fieldName,
              fieldType: item?.fieldType
                ? item?.fieldType?.toLowerCase()
                : item?.dataType?.toLowerCase(),
              filterCondition: item?.condition?.value,
              sqlExpression: item?.sqlValue,
              value1: item?.value1,
              value: item?.value,
              repository: item?.field?.repositoryName,
              tableColumnName: item?.field?.tableColumnName,
              dataRepositoryId: item?.field?.dataRepositoryId ? item?.field?.dataRepositoryId : 0,
              fieldId: item?.field?.repositoryFieldId
                ? item?.field?.repositoryFieldId
                : item?.field?.fieldId
                  ? item?.field?.fieldId
                  : 0,
              repositoryType:
                (item?.field?.repositoryName || '').toLowerCase() === 'data calculation field'
                  ? item?.field?.repositoryName
                  : 'DB',
            };
          }) :
          [];
      const singleData = data?.Date;
      const payload = {
        accessMethodInfo: {
          accessMethod: data?.accessMethod?.fieldCode ? data?.accessMethod?.fieldCode : '',
          endDate:
            data?.lastDate &&
            data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
            !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.lastDate)
              getValue(data?.lastDate) :
              '',
          action: data?.accessMethod?.fieldCode !== 'DBACCT' && data?.action ? data?.action : '',
          startDate:
            singleData &&
            data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
            !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(singleData)
              getValue(data?.Date) :
              data?.startDate &&
                data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
                !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.startDate)
                getValue(data?.startDate) :
                '',
          value:
            data?.accessMethod?.fieldCode === 'DBLSTDTE' ||
            ['Is Blank', 'Is Not Blank', 'BETWEEN', 'NOT BETWEEN']?.includes(data?.action) ?
              [] :
              getArrayData(selectedAccessMethod, data),
          repositoryName:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' && data?.repoitoryName?.repositoryName ?
              data?.repoitoryName?.repositoryName :
              '',
          fieldName:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' && data?.fieldsName?.fieldName ?
              data?.fieldsName?.fieldName :
              '',
          fromValue:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
            ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
            data?.fromValues ?
              data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
                getValue(data?.fromValues) :
                data?.fromValues :
              '',
          toValue:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
            ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
            data?.toValues ?
              data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
                getValue(data?.toValues) :
                data?.toValues :
              '',
        },
        defaultOperator: data?.resultExpCondition,
        reportCode: basicInfoData?.reportCode ? basicInfoData?.reportCode : '',
        reportId: reportCode ? reportCode : 0,
        reportRules: sqlRules,
        ruleExpression: data?.sqlExpression ? data?.sqlExpression : '',
        reportRulesDeleteIds: deletedRules?.length > 0 ? [...new Set(deletedRules)] : [0],
        // this for front end don't remove below payload
        isTestClicked: true,
        lastStep: clickedTestRef.current ? 2 : 3,
        reportType: workQueue ? 'WQ' : 'REPORT',
      };
      dispatch(postFilter(payload));
    }
  };
  const handleSub = () => {
    setSaveLoading(true);
    const data = formDataRef.current?.values;
    if (data) {
      const selectedAccessMethod = data?.accessMethod?.fieldCode;
      const sqlRules =
        data?.sqlRules?.length > 0 ?
          data?.sqlRules?.map((item, i) => {
            return {
              reportRulesId: item?.reportRulesId ? item?.reportRulesId : 0,
              ruleCode: item?.ruleCode,
              fieldName: item?.field?.fieldName,
              fieldType: item?.fieldType
                ? item?.fieldType?.toLowerCase()
                : item?.dataType?.toLowerCase(),
              filterCondition: item?.condition?.value,
              sqlExpression: item?.sqlValue,
              value1: item?.value1,
              value: item?.value,
              repository: item?.field?.repositoryName,
              tableColumnName: item?.field?.tableColumnName,
            };
          }) :
          [];
      const singleData = data?.Date;
      const payload = {
        accessMethodInfo: {
          accessMethod: data?.accessMethod?.fieldCode ? data?.accessMethod?.fieldCode : '',
          endDate:
            data?.lastDate &&
            data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
            !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.lastDate)
              getValue(data?.lastDate) :
              '',
          action: data?.accessMethod?.fieldCode !== 'DBACCT' && data?.action ? data?.action : '',
          startDate:
            singleData &&
            data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
            !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(singleData)
              getValue(data?.Date) :
              data?.startDate &&
                data?.accessMethod?.fieldCode === 'DBLSTDTE' &&
                !['Is Blank', 'Is Not Blank']?.includes(data?.action) ? // ? getFormattedDate(data?.startDate)
                getValue(data?.startDate) :
                '',
          value:
            data?.accessMethod?.fieldCode === 'DBLSTDTE' ||
            ['Is Blank', 'Is Not Blank', 'BETWEEN', 'NOT BETWEEN']?.includes(data?.action) ?
              [] :
              getArrayData(selectedAccessMethod, data),
          repositoryName:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' && data?.repoitoryName?.repositoryName ?
              data?.repoitoryName?.repositoryName :
              '',
          fieldName:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' && data?.fieldsName?.fieldName ?
              data?.fieldsName?.fieldName :
              '',
          fromValue:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
            ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
            data?.fromValues ?
              data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
                getValue(data?.fromValues) :
                data?.fromValues :
              '',
          toValue:
            data?.accessMethod?.fieldCode === 'DBUDWFIELDS' &&
            ['BETWEEN', 'NOT BETWEEN']?.includes(data?.action) &&
            data?.toValues ?
              data?.fieldsName?.fieldType?.toLowerCase() === 'date' ?
                getValue(data?.toValues) :
                data?.toValues :
              '',
        },
        defaultOperator: data?.resultExpCondition,
        reportCode: basicInfoData?.reportCode ? basicInfoData?.reportCode : '',
        reportId: reportCode ? reportCode : 0,
        reportRules: sqlRules,
        ruleExpression: data?.sqlExpression ? data?.sqlExpression : '',
        reportRulesDeleteIds: deletedRules?.length > 0 ? deletedRules : [0],
        // this for front end don't remove below payload
        isTestClicked: true,
        lastStep: clickedTestRef.current ? 2 : 3,
        reportType: workQueue ? 'WQ' : 'REPORT',
      };
      dispatch(postFilter(payload));
    }
  };

  const handleTest = (values) => {
    const sqlRules =
      values.sqlRules?.length > 0 ?
        values.sqlRules?.map((item, i) => {
          return {
            reportRulesId: item?.reportRulesId ? item?.reportRulesId : 0,
            ruleCode: item?.ruleCode,
            fieldName: item?.field?.fieldName,
            fieldType: item?.fieldType ?
              item?.fieldType?.toLowerCase() :
              item?.dataType?.toLowerCase(),
            filterCondition: item?.condition?.value,
            sqlExpression: item?.sqlValue,
            value1: item?.value1,
            value: item?.value,
            repository: item?.field?.repositoryName,
            tableColumnName: item?.field?.tableColumnName,
          };
        }) :
        [];
    const passValuesTest = {
      reportCode: basicInfoData?.reportCode,
      result: values?.sqlExpression,
      sqlRules: sqlRules,
      isReportFilter: true,
    };
    return passValuesTest;
  };
  return (
    <>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        enableReinitialize
        onSubmit={handleSubmit}
        innerRef={formDataRef}
      >
        {(props) => {
          const {
            values,
            setFieldValue,
            errors,
            dirty,
            touched,
            handleBlur,
            handleChange,
            submitForm,
          } = props;
          // handleDirty(dirty);
          const check = JSON.stringify(touched) === '{}' ? false : dirty;
          setDirtyVal(check);
          return (
            <>
              {workQueue ? (
                <BreadCrums
                  name={'Work Queue Name'}
                  code={basicInfoData?.reportCode}
                  description={'Work Queue Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              ) : (
                <BreadCrums
                  name={'Report Name'}
                  code={basicInfoData?.reportCode}
                  description={'Report Description'}
                  descriptionValue={basicInfoData?.reportDescription}
                />
              )}
              <Form noValidate>
                <div
                  className={`form-row border-bottom global-field-textfields new-standard-textfields`}
                >
                  <div
                    className={`col-sm-6 col-md-6 col-lg-3 col-xl-3 form-group autocomplete-field
                     `}
                  >
                    <GuiAutoComplete
                      classes={{
                        option: classes.option,
                      }}
                      name="accessMethod"
                      id="accessMethod"
                      size="small"
                      value={values?.accessMethod}
                      options={fieldCodeData || []}
                      getOptionDisabled={(option) => option.valueCode === null}
                      getOptionLabel={(option) => {
                        return option && option?.description ? option?.description : '';
                      }}
                      required
                      onChange={(_, data) => {
                        setSubmitted(false);
                        dispatch(getActions(data?.fieldCode));
                        if (['DBCLNT', 'DSSTAT', 'DBCOLLECTOR']?.includes(data?.fieldCode)) {
                          // dispatch(getActions(data?.fieldCode));
                          dirtyRef.current = true;
                          setFieldValue('action', 'IN');
                          dispatch(
                            postFieldCode({
                              fieldCode: data?.fieldCode,
                              options: 'IN',
                              // options: actionData[0],
                            }),
                          );
                          // setFieldValue("action", actionData[0]);
                        } else if (data?.fieldCode === 'DBUDWFIELDS') {
                          // dispatch(getActions(data?.fieldCode));
                          dirtyRef.current = true;
                          setFieldValue('action', 'NOT IN');
                          dispatch(
                            postFieldCode({
                              fieldCode: data?.fieldCode,
                              options: 'NOT IN',
                              // options: actionData[0],
                            }),
                          );
                        } else if (['DBLSTDTE', 'DSDISP']?.includes(data?.fieldCode)) {
                          setFieldValue('action', 'Is Blank');
                          dirtyRef.current = true;
                          // dispatch(getActions(data?.fieldCode));
                          dispatch(
                            postFieldCode({
                              fieldCode: data?.fieldCode,
                              options: 'Is Blank',
                              // options: actionData[0],
                            }),
                          );
                          // setFieldValue("action", actionData[0]);
                        }
                        setFieldValue('accessMethod', data);
                        filterMethodRef.current = data;
                        // if (data?.fieldCode && data.fieldCode !== "DBACCT") {
                        //   dispatch(getActions(data?.fieldCode));
                        //   dispatch(
                        //     postFieldCode({
                        //       fieldCode: data?.fieldCode,
                        //       values?.action ? values.action : "IN",
                        //     })
                        //   );
                        // }
                      }}
                      // InputLabelProps={{
                      //   shrink: true,
                      // }}
                      renderInput={(params) => (
                        <div className="select-field">
                          <GuiTextField
                            // className={`${classes.labelName} ${classes.selectLabel}`}
                            className={` ${classes.labelName}`}
                            {...params}
                            variant="outlined"
                            fullWidth
                            limitTags={1}
                            margin="dense"
                            label="Filter Method"
                            name="accessMethod"
                            required
                            InputLabelProps={{
                              shrink: true,
                            }}
                            error={Boolean(touched.accessMethod && errors.accessMethod)}
                            placeholder="Select Filter Method"
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'off',
                            }}
                          />
                        </div>
                      )}
                    />
                    <FormHelperText style={{color: 'red'}} variant="outlined">
                      {touched?.accessMethod && errors?.accessMethod && errors?.accessMethod}
                    </FormHelperText>
                  </div>
                  {values?.accessMethod?.fieldCode === 'DBUDWFIELDS' && (
                    <>
                      <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3 form-group autocomplete-field">
                        <FormControl margin="dense" variant="outlined" fullWidth>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            size="small"
                            value={values?.repoitoryName || ''}
                            getOptionLabel={(option) => {
                              return option && option?.repositoryName ? option?.repositoryName : '';
                            }}
                            onChange={(e, value) => {
                              setFieldValue('repoitoryName', value);
                              resetPromptDataRef.current = true;
                              setFieldValue('fieldsName', '');
                              setFieldValue('action', ' NOT IN');
                              if (values?.accessMethod?.fieldCode) {
                                dispatch(
                                  postFieldCode({
                                    fieldCode: values?.accessMethod?.fieldCode,
                                    options: 'NOT IN',
                                  }),
                                );
                              }

                              value?.repositoryName ? dispatch(fetchUserDefinedFields(value?.repositoryName)) : null;
                            }}
                            options={userDefinedWindowData}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  name={'repoitoryName'}
                                  onBlur={handleBlur}
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  variant="outlined"
                                  margin="dense"
                                  label={'Repository Name'}
                                  required
                                  error={Boolean(touched?.repoitoryName && errors?.repoitoryName)}
                                  placeholder={'Repository Name'}
                                />
                              </div>
                            )}
                          />
                        </FormControl>
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched?.repoitoryName && errors?.repoitoryName && errors?.repoitoryName}
                        </FormHelperText>
                      </div>
                      <div className="col-sm-6 col-md-6 col-lg-3 col-xl-3 form-group autocomplete-field">
                        <FormControl margin="dense" variant="outlined" fullWidth>
                          <GuiAutoComplete
                            classes={{
                              option: classes.option,
                            }}
                            size="small"
                            value={values?.fieldsName || ''}
                            onChange={(e, value) => {
                              setFieldValue('action', 'NOT IN');
                              resetPromptDataRef.current = true;
                              // if (!getfilterData?.accessMethodInfo?.accessMethod) {
                              if (values?.accessMethod?.fieldCode) {
                                dispatch(
                                  postFieldCode({
                                    fieldCode: values?.accessMethod?.fieldCode,
                                    options: 'NOT IN',
                                  }),
                                );
                              }

                              // }

                              setFieldValue('fieldsName', value);
                            }}
                            options={userDefinedFieldsData}
                            getOptionLabel={(option) => {
                              return option && option?.fieldName ? option.fieldName : '';
                            }}
                            renderInput={(params) => (
                              <div className="select-field">
                                <GuiTextField
                                  className={` ${classes.labelName}`}
                                  {...params}
                                  name={'fieldsName'}
                                  onBlur={handleBlur}
                                  variant="outlined"
                                  margin="dense"
                                  required
                                  error={Boolean(touched?.fieldsName && errors?.fieldsName)}
                                  label={'Field Name'}
                                  placeholder={'Enter Field Name'}
                                />
                              </div>
                            )}
                          />
                        </FormControl>
                        <FormHelperText style={{color: 'red'}} variant="outlined">
                          {touched?.fieldsName && errors?.fieldsName && errors?.fieldsName}
                        </FormHelperText>
                      </div>
                    </>
                  )}

                  {values?.accessMethod?.fieldCode && values?.accessMethod?.fieldCode !== 'DBACCT' && (
                    <>
                      <div className="col-sm-6 col-md-6 col-lg-2 col-xl-2 form-group autocomplete-field">
                        <GuiAutoComplete
                          classes={{
                            option: classes.option,
                          }}
                          name="action"
                          id="action"
                          size="small"
                          value={values?.action}
                          options={
                            values?.accessMethod?.fieldCode === 'DBUDWFIELDS' ?
                              getActionsValues(values?.fieldsName?.fieldType, actionData) :
                              actionData
                          }
                          getOptionLabel={(option) => {
                            return option ? option : '';
                          }}
                          required
                          onChange={(_, data) => {
                            resetPromptDataRef.current = true;
                            dirtyRef.current = true;
                            setFieldValue('action', data);
                            values?.accessMethod?.fieldCode &&
                              data &&
                              dispatch(
                                postFieldCode({
                                  fieldCode: values?.accessMethod?.fieldCode,
                                  options: data,
                                }),
                              );
                            formDataRef?.current?.validateForm();
                          }}
                          // InputLabelProps={{
                          //   shrink: true,
                          // }}
                          renderInput={(params) => (
                            <div className="select-field">
                              <GuiTextField
                                margin="dense"
                                className={` ${classes.labelName}`}
                                {...params}
                                variant="outlined"
                                InputLabelProps={{
                                  shrink: true,
                                }}
                                fullWidth
                                label="Action"
                                name="action"
                                required
                                placeholder="Select Action"
                                error={Boolean(touched.action && errors.action)}
                                inputProps={{
                                  ...params.inputProps,
                                  autoComplete: 'off',
                                }}
                              />
                              <FormHelperText style={{color: 'red'}} variant="outlined">
                                {touched?.action && errors?.action && errors?.action}
                              </FormHelperText>
                            </div>
                          )}
                        />
                      </div>

                      {values?.action && (
                        <>
                          <div className="col-sm-6 col-md-12 col-lg-7 col-xl-7 d-flex new-standard-textfields filter-textfield">
                            <GetAccessMethodFields
                              values={values}
                              formProps={props}
                              reportDialogData={values.accessMethod}
                              setFieldValue={setFieldValue}
                              accessMethodFields={promptData}
                              fieldCodeValue={values.accessMethod}
                              additionalInfoData={getfilterData?.accessMethodInfo}
                              renderedFrom={'Run Report'}
                              fieldSubmitted={fieldSubmitted}
                              setSubmitted={setSubmitted}
                              handleDirty={handleDirty}
                              resetPromptDataRef={resetPromptDataRef}
                              module={'reports'}
                              userDefinedWindowData={userDefinedWindowData}
                            />
                          </div>
                        </>
                      )}
                    </>
                  )}
                  {actionLoader && <PageLoader />}
                </div>
                <FieldArray
                  name="sqlRules"
                  render={(arrayHelpers) => {
                    return (
                      <>
                        {values.sqlRules.map((rule, index) => (
                          <Field
                            key={index}
                            // name={"selectedFields"+"[" + index + "]"}
                            name={`sqlRules[${index}]`}
                            component={SqlRuleBuilder}
                            index={index}
                            isReports={true}
                            // fields={formattedFieldList}
                            handleDelete={() => {
                              setIsDelete(true);
                              currentDeleteIndex.current = index;
                              arrayHelperRef.current = arrayHelpers;
                              // handleDirty(dirty);
                              dirtyRef.current = true;
                            }}
                          />
                        ))}
                        <div className="table-header new-standard-textfields mt-3">
                          {/* <Typography variant="h4"></Typography> */}
                          <RadioGroup
                            aria-label="resultExpCondition"
                            name="resultExpCondition"
                            value={values.resultExpCondition}
                            onBlur={handleBlur}
                            onChange={(e) => {
                              handleChange(e);
                              const result = values.sqlRules.map((el, i) => el.ruleCode);
                              resultRef.current = false;
                              setFieldValue('sqlExpression', result.join(` ${e.target.value} `));
                            }}
                            style={{
                              display: 'flex',
                              justifyContent: 'start',
                              flexDirection: 'row',
                            }}
                          >
                            <FormControlLabel
                              value="AND"
                              control={<Radio disabled={values.resultExpCondition == ''} />}
                              label="AND"
                            />
                            <FormControlLabel
                              value="OR"
                              control={<Radio disabled={values.resultExpCondition == ''} />}
                              label="OR"
                            />
                          </RadioGroup>

                          <div>
                            <Button
                              variant="outlined"
                              className={`search-btn mx-1 ${classes.buttonRoot}`}
                              disabled={!filterRuleRoleAccess?.add}
                              onClick={() => {
                                // arrayHelpers.push({
                                //   ruleCode:
                                //     values.sqlRules.length > 0
                                //       ? "S" +
                                //         (Number(
                                //           values.sqlRules[values.sqlRules.length - 1].ruleCode.slice(
                                //             1
                                //           )
                                //         ) +
                                //           1)
                                //       : "S1",
                                //   field: "",
                                //   condition: "",
                                //   value: "",
                                //   value1: "",
                                //   sqlValue: "",
                                // });
                                setOpen(true);
                              }}
                            >
                              <AddIcon />
                              Add Filter Rule
                            </Button>
                            {!workQueue && (
                              <Button
                                variant="outlined"
                                className={`search-btn mx-1 ${classes.buttonRoot}`}
                                disabled={!filterRuleRoleAccess?.add}
                                onClick={() => {
                                  setFilterRuleOpen(true);
                                }}
                              >
                                <AddIcon />
                                Add Data Calculations Filter Rule
                              </Button>
                            )}
                          </div>
                        </div>
                      </>
                    );
                  }}
                />
                <div className="d-flex justify-content-space-between align-items-center mt-0 global-field-textfields new-standard-textfields">
                  <div className="col-md-6 col-lg-4 col-xl-4 pl-0 form-group">
                    <TextField
                      className={` ${classes.labelName}`}
                      placeholder="Result Expression"
                      margin="dense"
                      name="sqlExpression"
                      variant="outlined"
                      label="Result Expression"
                      onBlur={handleBlur}
                      value={values?.sqlExpression}
                      // required
                      required={values.sqlRules.length > 0}
                      disabled={values.sqlRules.length === 0}
                      onChange={(e, value) => {
                        setFieldValue('sqlExpression', e.target.value);
                        if (e.target.value.length > 0) {
                          resultRef.current = true;
                          setFieldValue('resultExpCondition', '');
                        }
                        // setResultSql(e.target.valu e);
                      }}
                      InputLabelProps={{
                        shrink: true,
                      }}
                      error={values.sqlRules.length > 0 ? Boolean(errors.sqlExpression) : ''}
                      fullWidth
                    />
                    <FormHelperText style={{color: 'red'}} variant="outlined">
                      {values.sqlRules.length > 0 && errors.sqlExpression ?
                        errors.sqlExpression :
                        ''}
                    </FormHelperText>
                  </div>
                  <Button
                    variant="outlined"
                    className={`ml-auto search-btn ${classes.buttonRoot} mb-4`}
                    // disabled={!values?.sqlExpression}
                    onClick={() => {
                      // handleSubmit(values);
                      clickedTestRef.current = true;
                      setOpenTestForm(true);
                    }}
                  >
                    Test
                  </Button>
                </div>
                <div className="d-flex justify-content-center new-standard-textfields">
                  <Button
                    type="button"
                    onClick={() => {
                      handleBack();
                      dispatch(fetchReportFields(reportCode));
                    }}
                    variant="outlined"
                    className={`mx-1 reset-btn ${classes.buttonRoot}`}
                  >
                    Back
                  </Button>
                  {/* {isDraftReport === "N" && ( */}
                  <Button
                    variant="outlined"
                    type="submit"
                    className={`search-btn mx-1 ${classes.buttonRoot}`}
                    disabled={roleAccess || enabledSubmission}
                    onClick={() => {
                      clickedTestRef.current = true;
                      setSubmitted(true);
                      if (formDataRef.current.isValid) {
                        submitForm(values);
                      }
                      handleDirty(false, 'fixed');
                    }}
                  >
                    Save
                  </Button>
                  {/* )} */}
                  {/* {values?.sqlRules && values?.sqlRules?.length > 0 ? ( */}
                  <Button
                    type="submit"
                    variant="outlined"
                    className={`mx-1 search-btn ${classes.buttonRoot}`}
                    onClick={() => {
                      clickedTestRef.current = false;
                      setSubmitted(true);
                      if (formDataRef.current.isValid) {
                        submitForm(values);
                      }
                    }}
                    disabled={roleAccess || enabledSubmission}
                  >
                    Save & Next
                  </Button>
                  {/* // ) : (
                  //   <Tooltip title="Please add atleast one Filter rule to continue">
                  //     <span>
                  //       <Button
                  //         type="submit"
                  //         variant="outlined"
                  //         className={`mx-1 search-btn ${classes.buttonRoot}`}
                  //         disabled
                  //       >
                  //         Save & Next
                  //       </Button>
                  //     </span>
                  //   </Tooltip>
                  // )} */}
                </div>
                <DialogBox
                  open={open}
                  dialogClose={handleClose}
                  // title="Search Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Fields</b>
                      </p>
                      {workQueue ? (
                        <BreadCrums
                          name={'Work Queue Name'}
                          code={basicInfoData?.reportCode}
                          description={'Work Queue Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      ) : (
                        <BreadCrums
                          name={'Report Name'}
                          code={basicInfoData?.reportCode}
                          description={'Report Description'}
                          descriptionValue={basicInfoData?.reportDescription}
                        />
                      )}
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchFields
                    isReportsFilter={true}
                    isReports={true}
                    resultExpCondition={values.resultExpCondition}
                    setRules={(value) => {
                      setFieldValue('sqlRules', value);
                    }}
                    rules={values.sqlRules}
                    resultRef={resultRef}
                    tempSelectedRows={tempSelectedRows}
                    handleClose={handleClose}
                    mapFields={true}
                    setTempSelectedRows={setTempSelectedRows}
                    setInitialValues={setInitialValues}
                    setFieldValue={setFieldValue}
                    filterValues={values}
                    filterMethodRef={filterMethodRef}
                  />
                </DialogBox>
                <DialogBox
                  open={filterRuleOpen}
                  dialogClose={handleClose}
                  // title="Search Data Calculations Fields"
                  title={
                    <div className="dialog-breadcrum">
                      <p className="dialoge-title-breadcrum">
                        <b>Search Data Calculations Fields</b>
                      </p>
                      <BreadCrums
                        name={'Report Name'}
                        code={basicInfoData?.reportCode}
                        description={'Report Description'}
                        descriptionValue={basicInfoData?.reportDescription}
                      />
                    </div>
                  }
                  maxWidth="xl"
                >
                  <SearchDataCalculationFields
                    isReportsFilter={true}
                    isReports={true}
                    resultExpCondition={values.resultExpCondition}
                    setRules={(value) => {
                      setFieldValue('sqlRules', value);
                    }}
                    rules={values.sqlRules}
                    resultRef={resultRef}
                    tempSelectedRows={tempSelectedRows}
                    handleFilterClose={handleClose}
                    mapFields={true}
                    setTempSelectedRows={setTempSelectedRows}
                    setInitialValues={setInitialValues}
                    setFieldValue={setFieldValue}
                    filterValues={values}
                    filterMethodRef={filterMethodRef}
                  />
                </DialogBox>
                {values.sqlRules[currentDeleteIndex.current] && (
                  <DeleteTableRecordPopup
                    open={isDelete}
                    dialogClose={handleDeleteClose}
                    title="Delete SQL Rule"
                    value={`Are you sure you want to delete the ${
                      values.sqlRules[currentDeleteIndex.current].ruleCode
                    } Filter Rule?`}
                    handleSubmit={handleDeleteRule}
                  />
                )}
                <DialogBox
                  open={openTestForm}
                  dialogClose={handleTestFormClose}
                  title={
                    <>
                      <span>
                        <b>{'Run Test For'} :</b>
                      </span>
                      <span className="result-expression">{values?.sqlExpression} </span>
                    </>
                  }
                  maxWidth="lg"
                >
                  <TestComponent passValuesTest={handleTest(values)} isReportTest={true}  reportId={reportCode} />
                </DialogBox>
              </Form>
              <DeleteTableRecordPopup
                open={validate}
                dialogClose={handleValidationClose}
                title="Warning !"
                value={`Filter Rule hasn't been added, Would you like to Skip and Continue?`}
                handleSubmit={handleSub}
              />
            </>
          );
        }}
      </Formik>
      {saveLoading && <PageLoader />}
      {errorMsg && <ErrorSnackbar errorMsg={errorMsg} />}
      {successMsg && <SuccessSnackbar successMsg={successMsg} />}
    </>
  );
};

export default Filters;
